module.exports = __webpack_public_path__ + "img/setxrm-read-all-blogs.526b4e84.png";